import { Modal } from "@mui/material";
import React, { useState } from "react";
import CustomerApi from "../../../../../API/CustomerApi";
import Swal from "sweetalert2";

const FiberCompetitionForm = ({ open, setOpen, customer }) => {
  const [oneGigCompetitive, setOneGigCompetitive] = React.useState(false);
  const [twoGigCompetitive, setTwoGigCompetitive] = React.useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith("image/")) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedFile((prev) => ({ ...prev, base64: reader.result.split(",")[1] }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedFile((prev) => ({ name:file.name, base64: reader.result.split(",")[1] }));
        console.log("Base64 String:", reader.result.split(",")[1]);
        console.log("File Name:", file.name);
    };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit =async () => {
    if (!selectedFile?.base64) {
        Swal.fire({
            icon: "error",
            title: "Error",
            text: "Please upload the Proof.",
        });
      return;
    }

    if (!oneGigCompetitive && !twoGigCompetitive) {
        Swal.fire({
            icon: "error",
            title: "Error",
            text: "Please select one plan.",
        });
        return;
    }

    Swal.fire({
        icon: "info",
        title: "Submitting",
        text: "Please wait...",
        showConfirmButton: false,
        didOpen: () => {
            Swal.showLoading();
        }

    });

    const req = {
      customerId: customer.id,
      attachment: {
        fileName: selectedFile.name,
        base64string: selectedFile.base64,
      },
      planSelected: oneGigCompetitive? 1 : twoGigCompetitive? 2 : null, 
    };

    const res =await CustomerApi.SendFiberCompetitiveMail(req);

    if (res?.status?.success) {
        Swal.fire({
            icon: "success",
            title: "Success",
            text: "Fiber competition form submitted successfully.",
        });
    } else {
        Swal.fire({
            icon: "error",
            title: "Error",
            text: res?.status?.message || "Something went wrong.",
        });
    }


    console.log("Request payload:", req);
    // Add API call logic here
  };

  return (
    <Modal
      setOpen={setOpen}
      minHeight={"80vh"}
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <div
        className="custom_modal"
        style={{
          maxHeight: "90vh",
          paddingTop: "20px",
          padding: "20px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        {customer?.fiberCompanyId === 15 && (
          <img
            style={{ width: "250px", marginBottom: "20px" }}
            src="/images/offer/ezee/ezeelogo.png"
            alt="Authorized Point Broadband"
          />
        )}
        <p className="active font-bold text-lg mb-4">Competitive Fiber Offer</p>
        <div className="inputs">
          <div className="toggle-switch mb-4">
            <label className="font-medium">$49 1Gig</label>
            <input
              type="checkbox"
              checked={oneGigCompetitive}
              onChange={() => {
                setOneGigCompetitive(!oneGigCompetitive);
                if (twoGigCompetitive) {
                  setTwoGigCompetitive(false);
                }
              }}
            />
          </div>
          <div className="toggle-switch mb-4">
            <label className="font-medium">$69 2Gig</label>
            <input
              type="checkbox"
              checked={twoGigCompetitive}
              onChange={() => {
                setTwoGigCompetitive(!twoGigCompetitive);
                if (oneGigCompetitive) {
                  setOneGigCompetitive(false);
                }
              }}
            />
          </div>
          {previewUrl ? (
            <div className="relative">
              <img
                src={previewUrl}
                alt="Preview"
                className="upload-preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "200px",
                  borderRadius: "8px",
                  border: "1px solid #ddd",
                }}
              />
              <label
                htmlFor="fileInput"
                className="absolute top-2 right-2 bg-gray-800 text-white p-1 rounded-full cursor-pointer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "30px",
                  height: "30px",
                }}
              >
                ✏️
              </label>
              <input
                type="file"
                accept="image/*"
                className="hidden"
                id="fileInput"
                onChange={handleFileChange}
              />
            </div>
          ) : (
            <div
              className={`upload-area ${isDragging ? "dragover" : ""}`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
            >
              <div className="file-input-wrapper">
                <input
                  type="file"
                  accept="image/*"
                  className="file-input"
                  onChange={handleFileChange}
                  id="fileInput"
                />
                <label htmlFor="fileInput">
                  <div>
                    <p>Upload your Bill here</p>
                  </div>
                </label>
              </div>
            </div>
          )}
        </div>
        <div className="flex justify-end mt-4">
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default FiberCompetitionForm;
